import { Routes } from '@angular/router';
import { MainPageComponent } from './pages';
import { HomeComponent } from '@app/pages/main-page/home/home.component';
import { MenuComponent } from '@app/pages/main-page/menu/menu.component';
import { ServiceComponent } from '@app/pages/main-page/service/service.component';
import { SpecialOfferComponent } from './pages/main-page/special-offer/special-offer.component';
import { MoreComponent } from '@app/pages/main-page/more/more.component';
import { PromosComponent } from '@app/pages/main-page/promos/promos.component';

export const appRoutes: Routes = [
  {
    path: 'main',
    component: MainPageComponent,
    data: { screen: 'main' },
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { animation: 'Home', screen: 'Home' },
      },
      {
        path: 'menu',
        component: MenuComponent,
        data: { animation: 'Menu', screen: 'Menu' },
      },
      {
        path: 'promos',
        component: PromosComponent,
        data: { animation: 'Promos', screen: 'Promos' },
      },
      {
        path: 'service',
        component: ServiceComponent,
        data: { animation: 'Service', screen: 'Service' },
      },
      {
        path: 'more',
        component: MoreComponent,
        data: { animation: 'More', screen: 'More' },
      },
      {
        path: 'special-offer',
        component: SpecialOfferComponent,
        data: { animation: 'SpecialOffer', screen: 'SpecialOffer' },
      },
    ],
  },
];
